import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

const AnimatedCounter = ({ end }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 1500; // 1 ثانية
    const frameRate = 60; // 60 إطار في الثانية
    const totalFrames = Math.round((duration / 1000) * frameRate);
    const increment = end / totalFrames;
    let frame = 0;

    const counter = setInterval(() => {
      frame++;
      const progress = Math.round(increment * frame);
      if (progress >= end) {
        setCount(end);
        clearInterval(counter);
      } else {
        setCount(progress);
      }
    }, 1000 / frameRate);

    return () => clearInterval(counter);
  }, [end]);

  return <span>{count}</span>;
};

const Statistics = ({ statisticsData }) => {
  const { locale } = useRouter();

  return (
    <div className="statistics">
      <Container>
        <Row>
          {statisticsData?.map((item, index) => {
            return (
              <Col lg={3} md={6} sm={12} xs={12} key={index}>
                <div 
                  className="stat-item h-100"
                  data-aos="fade-up"
                  data-aos-duration={(index + 1) * 100}
                  data-aos-delay={(index + 1) * 100}
               
                  
                >
                  <h3 className="count">
                    <AnimatedCounter
                      end={parseFloat(item?.count.replace(/[^\d.]/g, ""))}
                    />
                    {item?.count.replace(/[\d.]/g, "")}
                  </h3>
                  <p className="title">{item?.sectionTitle?.[locale]}</p>
                  <p className="subtitle">{item?.sectionSubTitle?.[locale] || ''}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default Statistics;
